import {
    FETCH_ASSIGN_SUCCESS
} from "./type";

import axios from "axios";
import { API_ENDPOINT } from '../../AppConfig';
import { hideLoading, showLoading } from 'react-redux-loading-bar';

export function GetAssignRequest(token, Id) {
    return (dispatch, getState) => {
        dispatch(showLoading());
        let uri = `${API_ENDPOINT}/assigRule?user=${Id}`;
        axios.get(uri, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => {
                dispatch(hideLoading());
                // console.log("response ASSIGNSUBB", response.data.data)
                dispatch({ type: FETCH_ASSIGN_SUCCESS, payload: response.data.data });
            }).catch(error => {
                // console.log("Error ASSIGNSUBB", error)
                dispatch(hideLoading());
                
            })
    }
}

export function saveToLocalStorage(key, value) {
    localStorage.setItem(key, value);
}
